<script>
import ProposalList from "@/components/widgets/proposal-list.vue";
import ChangeExpenditureModal from "@/components/modals/change-expenditure-modal.vue";
import FundSourceModal from "@/components/modals/fund-source-list.vue";
import { groupBy } from "lodash";
export default {
    name: "BudgetProposalBackPage",
    components: {
        ProposalList,
        ChangeExpenditureModal,
        FundSourceModal,
    },
    props: {
        selectedTemplate: {
            type: Object,
            required: true,
        },
        budgets: {
            type: Array,
            default: () => [],
        },
        viewFrom: {
            type: String,
            default: "planning",
        },
    },
    data() {
        return {
            tabModel: null,
            activeProposals: [],
            shortlistedProposals: [],
            parkedProposals: [],
            approvedProposals: [],
            returnedProposals: [],
            loading: false,
            pendingSelectedItems: [],
            pendingTargetApi: null,
        };
    },
    watch: {
        tabModel: {
            immediate: true,
            async handler(newVal) {
                this.loading = true;
                if (newVal === 0) {
                    await this.getActiveProposals(this.selectedTemplate.id);
                } else if (newVal === 1) {
                    await this.getReturnedProposals(this.selectedTemplate.id);
                } else if (newVal === 2) {
                    await this.getShortlistedProposals(this.selectedTemplate.id);
                } else if (newVal === 3) {
                    await this.getParkedProposals(this.selectedTemplate.id);
                } else if (newVal === 4) {
                    await this.getApprovedProposals(this.selectedTemplate.id);
                }
                this.loading = false;
            },
        },
    },
    mounted() {
        this.tabModel = 0;
    },
    methods: {
        async getActiveProposals(templateId) {
            if (this.activeProposals.length) return;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetPostedBudgetProposal", templateId);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                response.map(item => {
                    item.resources = [];
                    item.showResources = false;
                    item.resourceLoading = false;
                    item.searchItem = "";
                    item.statusUpdate = "";
                })
                this.activeProposals = response ? this.formatResponse(response) : [];
            } catch (error) {
                this.showToast("Failed to fetch active proposals.", "error");
            }
        },
        async getShortlistedProposals(templateId) {
            if (this.shortlistedProposals.length) return;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetShortListedBudgetProposals", templateId);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                response.map(item => {
                    item.resources = [];
                    item.showResources = false;
                    item.resourceLoading = false;
                    item.searchItem = "";
                    item.statusUpdate = "";
                })
                this.shortlistedProposals = response ? this.formatResponse(response) : [];
            } catch (error) {
                this.showToast("Failed to fetch shortlisted proposals.", "error");
            }
        },
        async getReturnedProposals(templateId) {
            if (this.returnedProposals.length) return;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetReturnedBudgetProposals", templateId);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                response.map(item => {
                    item.resources = [];
                    item.showResources = false;
                    item.resourceLoading = false;
                    item.searchItem = "";
                    item.statusUpdate = "";
                })
                this.returnedProposals = response ? this.formatResponse(response) : [];
            } catch (error) {
                this.showToast("Failed to fetch returned proposals.", "error");
            }
        },
        async getParkedProposals(templateId) {
            if (this.parkedProposals.length) return;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetParkedBudgetProposals", templateId);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                response.map(item => {
                    item.resources = [];
                    item.showResources = false;
                    item.resourceLoading = false;
                    item.searchItem = "";
                    item.statusUpdate = "";
                })
                this.parkedProposals = response ? this.formatResponse(response) : [];
            } catch (error) {
                this.showToast("Failed to fetch parked proposals.", "error");
            }
        },
        async getApprovedProposals(templateId) {
            if (this.approvedProposals.length) return;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetApprovedBudgetProposals", templateId);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                response.map(item => {
                    item.resources = [];
                    item.showResources = false;
                    item.resourceLoading = false;
                    item.searchItem = "";
                    item.statusUpdate = "";
                })
                this.approvedProposals = response ? this.formatResponse(response) : [];
            } catch (error) {
                this.showToast("Failed to fetch approved proposals.", "error");
            }
        },
        formatResponse(response) {
            let formatted = [];
            let index = 0;
            let grp = groupBy(response, "campusId");
            for (let campusId in grp) {
                let grpByDu = groupBy(grp[campusId], "deliveryUnitId");
                let dus = [];
                for (let duId in grpByDu) {
                    dus.push({
                        id: duId,
                        deliveryUnit: grpByDu[duId][0].deliveryUnit,
                        proposals: grpByDu[duId],
                        isOpen: false,
                    });
                }
                formatted.push({
                    id: campusId,
                    campus: grp[campusId][0].campus,
                    isOpen: index == 0 ? true : false,
                    dus: dus,
                });
                index++;
            }
            return formatted;
        },
        changeExpenditure(resource) {
            this.$refs.changeExpenditureModal.open(resource);
            this.$emit("change-expenditure", resource);
        },
        changeFS({ selectedItems, targetApi, campus, campusId } = {}) {
            const items = selectedItems || [];
            if (!items || items.length === 0) {
                return this.showToast("Please select items to assign fund source.", "warning");
            }
            this.pendingSelectedItems = items;
            this.pendingTargetApi = targetApi;

            if (this.$refs.fundSourceModal) {
                this.$refs.fundSourceModal.getData(this.$store.state.data?.selectedCampus?.id);
            }
            this.$bvModal.show("fund-source-modal");
        },
        async onFundSourceSelected(fundSource) {
            if (!fundSource || !fundSource.id) {
                return;
            }
            if (!this.pendingSelectedItems || this.pendingSelectedItems.length === 0) {
                return;
            }
            try {
                const data = {
                    fundSourceId: fundSource.id,
                    fromFinance: true,
                    ids: this.pendingSelectedItems.map((item) => ({ id: item.id })),
                };
                const res = await this.$store.dispatch(
                    "planningapiresource/SetFSPlanningApiResource",
                    data
                );
                const response = res && res.data !== undefined ? res.data : res;
                if (response && response.error) {
                    return this.showToast(response.errorMessage || response.message || "Failed to set fund source.", "error");
                }

                this.pendingSelectedItems.forEach((item) => {
                    this.$set(item, "fundSource", fundSource.sourceName);
                    this.$set(item, "fundSourceId", fundSource.id);
                });

                this.showToast("Fund source assigned successfully.", "success");
            } catch (error) {
                this.showToast("Failed to set fund source.", "error");
            } finally {
                this.pendingSelectedItems = [];
                this.pendingTargetApi = null;
            }
        },
    },
}
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-3 mb-4">
                <a href="javascript:void(0);" @click="$emit('back')" class="d-flex align-items-center gap-1"><i
                        class="bx bx-chevron-left"></i> Back</a>
                <h4 class="mb-0">{{ selectedTemplate.description }} - Proposals</h4>
            </div>
            <div class="d-flex gap-1">
                <b-dropdown id="dropdown-dropleft" right variant="purple" toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end" no-caret>
                    <template #button-content>
                        <i class="bx bx-printer"></i>
                        Reports
                        <i class="bx bx-chevron-down me-1"></i>
                    </template>
                    <b-dropdown-item @click="$emit('print-form8', { templateId: selectedTemplate.id })">
                        Form 2 - RDC
                    </b-dropdown-item>
                    <b-dropdown-item @click="$emit('print-form8', { templateId: selectedTemplate.id })">
                        Form 8 - Budget Summary
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="$emit('print-dbm-form8', { templateId: selectedTemplate.id, campusId: null })">
                        DBM Form 8
                    </b-dropdown-item>
                    <b-dropdown-item @click="$emit('print-overall-summary', selectedTemplate.id)">
                        Overall Summary
                    </b-dropdown-item>
                </b-dropdown>
                <button class="btn btn-info" @click="$emit('view-summary')">
                    View Summary
                    <i class="bx bx-chevron-right me-1"></i>
                </button>
            </div>
        </div>
        <template v-if="loading">
            <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
                <b-spinner label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-tabs v-model="tabModel" color="primary">
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-check me-1"></i>Active Proposals</span>
                    </template>
                    <ProposalList :proposals="activeProposals" :loading="loading" type="active" :viewFrom="viewFrom"
                        :selectedTemplate="selectedTemplate" :budgets="budgets"
                        @view-resources="$emit('view-resources', $event)"
                        @show-api-attachments="$emit('show-api-attachments', $event)"
                        @show-api-logs="$emit('show-api-logs', $event)"
                        @view-proposal-data="$emit('view-proposal-data', $event)"
                        @approve-proposal="$emit('approve-proposal', $event)"
                        @return-proposal="$emit('return-proposal', $event)"
                        @shortlist-proposal="$emit('shortlist-proposal', $event)"
                        @park-proposal="$emit('park-proposal', $event)" @add-comment="$emit('add-comment', $event)"
                        @print-form8="$emit('print-form8', { ...$event, templateId: selectedTemplate.id, status: 'DRAFT' })"
                        @print-form2="$emit('print-form2', { ...$event, templateId: selectedTemplate.id, status: 'DRAFT' })"
                        @print-form5="$emit('print-form5', { ...$event, templateId: selectedTemplate.id })"
                        @print-form7="$emit('print-form7', { ...$event, templateId: selectedTemplate.id })"
                        @print-dbm-form8="$emit('print-dbm-form8', { ...$event, templateId: selectedTemplate.id })"
                        @change-expenditure="changeExpenditure($event)" @assign-fund-source="changeFS($event)"
                        @view-attachments="$emit('view-attachments', $event)" />
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-reply me-1"></i>Returned
                            Proposals</span>
                    </template>
                    <ProposalList :proposals="returnedProposals" :loading="loading" type="returned" :viewFrom="viewFrom"
                        :selectedTemplate="selectedTemplate" :budgets="budgets"
                        @view-resources="$emit('view-resources', $event)"
                        @show-api-attachments="$emit('show-api-attachments', $event)"
                        @show-api-logs="$emit('show-api-logs', $event)"
                        @view-proposal-data="$emit('view-proposal-data', $event)"
                        @approve-proposal="$emit('approve-proposal', $event)"
                        @return-proposal="$emit('return-proposal', $event)"
                        @park-proposal="$emit('park-proposal', $event)" @add-comment="$emit('add-comment', $event)"
                        @print-form8="$emit('print-form8', { ...$event, templateId: selectedTemplate.id, status: 'RETURNED' })"
                        @print-form2="$emit('print-form2', { ...$event, templateId: selectedTemplate.id, status: 'RETURNED' })"
                        @print-form5="$emit('print-form5', { ...$event, templateId: selectedTemplate.id })"
                        @print-form7="$emit('print-form7', { ...$event, templateId: selectedTemplate.id })"
                        @print-dbm-form8="$emit('print-dbm-form8', { ...$event, templateId: selectedTemplate.id })"
                        @change-expenditure="changeExpenditure($event)" @assign-fund-source="changeFS($event)"
                        @view-attachments="$emit('view-attachments', $event)" />
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-receipt me-1"></i>Shortlisted
                            Proposals</span>
                    </template>
                    <ProposalList :proposals="shortlistedProposals" :loading="loading" type="shortlisted"
                        :viewFrom="viewFrom" :selectedTemplate="selectedTemplate" :budgets="budgets"
                        @view-resources="$emit('view-resources', $event)"
                        @show-api-attachments="$emit('show-api-attachments', $event)"
                        @show-api-logs="$emit('show-api-logs', $event)"
                        @view-proposal-data="$emit('view-proposal-data', $event)"
                        @approve-proposal="$emit('approve-proposal', $event)"
                        @return-proposal="$emit('return-proposal', $event)"
                        @park-proposal="$emit('park-proposal', $event)" @add-comment="$emit('add-comment', $event)"
                        @print-form8="$emit('print-form8', { ...$event, templateId: selectedTemplate.id, status: 'SHORTLISTED' })"
                        @print-form2="$emit('print-form2', { ...$event, templateId: selectedTemplate.id, status: 'SHORTLISTED' })"
                        @print-form5="$emit('print-form5', { ...$event, templateId: selectedTemplate.id })"
                        @print-form7="$emit('print-form7', { ...$event, templateId: selectedTemplate.id })"
                        @print-dbm-form8="$emit('print-dbm-form8', { ...$event, templateId: selectedTemplate.id })"
                        @change-expenditure="changeExpenditure($event)" @assign-fund-source="changeFS($event)"
                        @view-attachments="$emit('view-attachments', $event)" />
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-car me-1"></i>Parked Proposals</span>
                    </template>
                    <ProposalList :proposals="parkedProposals" :loading="loading" type="parked" :viewFrom="viewFrom"
                        :selectedTemplate="selectedTemplate" :budgets="budgets"
                        @view-resources="$emit('view-resources', $event)"
                        @show-api-attachments="$emit('show-api-attachments', $event)"
                        @show-api-logs="$emit('show-api-logs', $event)"
                        @view-proposal-data="$emit('view-proposal-data', $event)"
                        @approve-proposal="$emit('approve-proposal', $event)"
                        @return-proposal="$emit('return-proposal', $event)"
                        @shortlist-proposal="$emit('shortlist-proposal', $event)"
                        @add-comment="$emit('add-comment', $event)"
                        @print-form8="$emit('print-form8', { ...$event, templateId: selectedTemplate.id, status: 'PARKED' })"
                        @print-form2="$emit('print-form2', { ...$event, templateId: selectedTemplate.id, status: 'PARKED' })"
                        @print-form5="$emit('print-form5', { ...$event, templateId: selectedTemplate.id })"
                        @print-form7="$emit('print-form7', { ...$event, templateId: selectedTemplate.id })"
                        @print-dbm-form8="$emit('print-dbm-form8', { ...$event, templateId: selectedTemplate.id })"
                        @change-expenditure="changeExpenditure($event)" @assign-fund-source="changeFS($event)"
                        @view-attachments="$emit('view-attachments', $event)" />
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-check-shield me-1"></i>Approved
                            Proposals</span>
                    </template>
                    <ProposalList :proposals="approvedProposals" :loading="loading" type="approved" :viewFrom="viewFrom"
                        :selectedTemplate="selectedTemplate" :budgets="budgets"
                        @view-resources="$emit('view-resources', $event)"
                        @show-api-attachments="$emit('show-api-attachments', $event)"
                        @show-api-logs="$emit('show-api-logs', $event)"
                        @view-proposal-data="$emit('view-proposal-data', $event)"
                        @return-proposal="$emit('return-proposal', $event)" @add-comment="$emit('add-comment', $event)"
                        @print-form8="$emit('print-form8', { ...$event, templateId: selectedTemplate.id, status: 'APPROVED' })"
                        @print-form2="$emit('print-form2', { ...$event, templateId: selectedTemplate.id, status: 'APPROVED' })"
                        @print-form5="$emit('print-form5', { ...$event, templateId: selectedTemplate.id })"
                        @print-form7="$emit('print-form7', { ...$event, templateId: selectedTemplate.id })"
                        @print-dbm-form8="$emit('print-dbm-form8', { ...$event, templateId: selectedTemplate.id })"
                        @change-expenditure="changeExpenditure($event)" @assign-fund-source="changeFS($event)"
                        @view-attachments="$emit('view-attachments', $event)" />
                </b-tab>
            </b-tabs>
        </template>
        <ChangeExpenditureModal ref="changeExpenditureModal" :budgets="budgets" />
        <FundSourceModal ref="fundSourceModal" @dropData="onFundSourceSelected" />
    </div>
</template>